import { jsx as t } from "../../_virtual/jsx-runtime.mjs";
import * as l from "react";
import { w as d } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import y from "./Image.mjs";
import u from "./Video.mjs";
import b from "./Youtube.mjs";
import { NO_LOOP_THRESHOLD as S, LOOP_THRESHOLD as s } from "./const.mjs";
const i = l.forwardRef((e, m) => {
  const a = l.useMemo(() => {
    var n;
    if (e.threshold || e.type === "image")
      return e.threshold;
    const { loop: o, autoplay: c } = ((n = e[e.type]) == null ? void 0 : n.pc) ?? {};
    return c && !o ? S : s;
  }, [e]);
  switch (e.type) {
    case "youtube":
      return /* @__PURE__ */ t(
        b,
        {
          threshold: a,
          ref: m,
          btnClassName: e.btnClassName,
          btnStyle: e.btnStyle,
          commonClassName: e.commonClassName,
          commonStyle: e.commonStyle,
          videoBtnSize: e.videoBtnSize,
          className: e.youtubeClassName,
          style: e.youtubeStyle,
          youtube: e.youtube,
          breakpoint: e.breakpoint,
          children: e.children
        }
      );
    case "video":
      return /* @__PURE__ */ t(
        u,
        {
          threshold: a,
          ref: m,
          btnClassName: e.btnClassName,
          btnStyle: e.btnStyle,
          commonClassName: e.commonClassName,
          commonStyle: e.commonStyle,
          videoBtnSize: e.videoBtnSize,
          className: e.videoClassName,
          style: e.videoStyle,
          videoBtnType: e.videoBtnType,
          video: e.video,
          breakpoint: e.breakpoint,
          children: e.children
        }
      );
    case "image":
      return /* @__PURE__ */ t(
        y,
        {
          commonClassName: e.commonClassName,
          commonStyle: e.commonStyle,
          className: e.imageClassName,
          style: e.imageStyle,
          image: e.image,
          breakpoint: e.breakpoint,
          children: e.children
        }
      );
    default:
      return null;
  }
});
i.displayName = "Media";
const g = d(i, {});
export {
  g as default
};
//# sourceMappingURL=Media.mjs.map
